export default {
    title: "管理用戶",
    table1: "用戶ID",
    table2: "登錄名",
    table3: "等級",
    table4: "部門編號",
    table5: "部門名稱",
    table6: "操作",
    isDel: "是否刪除當前用戶？",
    addTitle: "添加用戶",
    form1: "選擇等級",
    form2: "ID",
    form3: "登錄名",
    form4: "密碼",
    form5: "郵箱",
    form6: "聯絡人姓名",
    form7: "所屬市場",
    form8: "所屬公司",
    form9: "所屬部門",
    form10: "權限",
    form11: "已有地址",
    form12: "選擇地址",
    form13: "跨部門管理",
    form14: "跨部門打單",
    form15: "跨部門檢查訂單",
    form16: "訂單指定審批",
    form17: "超出需審批金額",
    form18: "單筆限制金額",
    form19: "月限制金額",
    form20: "開啟金額累計",
	form21: "無部門",
	form22: "報價單審批",
	form23: "員工編號",
	form24: "單筆限制最低金額",
    checkAll: "全選",
    power1: "管理子公司/分行",
    power2: "管理部門",
    power3: "管理收貨地址",
    power4: "修改密碼",
    power5: "管理用戶",
    power6: "報價",
    power7: "下訂單",
    address1: "收貨人姓名",
    address2: "收貨地址",
    addressRemarks: "（注：此操作將在該用戶已有地址上添加地址）",
    transfer1: "可選列表",
    transfer2: "已指定列表",
    exceedRemarks: "注：若不設置或設置金額為0，則下單必須審批",
    month1: "1月",
    month2: "2月",
    month3: "3月",
    month4: "4月",
    month5: "5月",
    month6: "6月",
    month7: "7月",
    month8: "8月",
    month9: "9月",
    month10: "10月",
    month11: "11月",
    month12: "12月",
    errmsg1: "您還未指定等級！",
    errmsg2: "您當前月限制金額總金額已超過剩餘分配金額，請重新分配！",
    diaTitle: "編輯修改",
    rule1: "註冊後不能修改",
    rule2: "長度為6~32個字符（2~10個中文）",
    rule3: "不可包含空格或特殊字符",
    rule4: "支持數字，大小寫字母，中文",
    rule5: "長度為6~32個字符",
    rule6: "不可包含空格",
    rule7: "支持數字，大小寫字母",
    rule8: "不輸入默認不修改",
    remark: "註：若同時設置單筆限制金額和超出需審批金額，則單筆限制金額要大於超出需審批金額。",
	remark2: "註：若同時設置單筆限制金額和超出需審批金額，則單筆限制金額要大於超出需審批金額。"
}